import React from 'react';
import PropTypes from 'prop-types';
import styles from './KeepersTable.module.css';
import Button from './Button.js';

const KeepersTable = ({ data, columns }) => {
  return (
    <div className={styles.keepersTableContainer}>
      <table className={styles.keepersTable}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.name}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row._id || index}>
              {columns.map((column) => (
                <td key={column.name}>
                  {column.render // Check if the column has a render function which we will use to reder the edit button
                    ? column.render(row)
                    : column.name === 'teamManager'
                      ? row[column.name]?.userName || 'Unknown'
                      : row[column.name]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

KeepersTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func, // optional render function
    })
  ).isRequired,
};

export default React.memo(KeepersTable); // Use React.memo to optimize performance


